import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function dashboardReducer(
  state = initialState.dashboard,
  action
) {
  switch (action.type) {
    case types.TOTAL_API_CALLS_SUCCESS:
      return {
        ...state.dashboard,
        totalApiCalls: action.totalApiCalls,
        fincludeTotalApps: state.fincludeTotalApps,
        finstreamTotalApps: state.finstreamTotalApps,
        successRate: state.successRate,
        totalChargeableCalls: state.totalChargeableCalls,
        finscoreTotalUploads: state.finscoreTotalUploads,
      };
    case types.SUCCESS_RATE_SUCCESS:
      return {
        ...state.dashboard,
        successRate: action.successRate,
        fincludeTotalApps: state.fincludeTotalApps,
        finstreamTotalApps: state.finstreamTotalApps,
        totalApiCalls: state.totalApiCalls,
        totalChargeableCalls: state.totalChargeableCalls,
        finscoreTotalUploads: state.finscoreTotalUploads,
      };
    case types.TOTAL_CHARGEABLE_CALLS_SUCCESS:
      return {
        ...state.dashboard,
        totalChargeableCalls: action.totalChargeableCalls,
        fincludeTotalApps: state.fincludeTotalApps,
        finstreamTotalApps: state.finstreamTotalApps,
        totalApiCalls: state.totalApiCalls,
        successRate: state.successRate,
        finscoreTotalUploads: state.finscoreTotalUploads,
      };

    case types.FINSCORE_FILE_UPLOADS_SUCCESS:
      return {
        ...state.dashboard,
        finscoreTotalUploads: action.count,
        fincludeTotalApps: state.fincludeTotalApps,
        finstreamTotalApps: state.finstreamTotalApps,
        totalChargeableCalls: state.totalChargeableCalls,
        totalApiCalls: state.totalApiCalls,
        successRate: state.successRate,
      };

    case types.FINCLUDE_APPS_SUCCESS:
      return {
        ...state.dashboard,
        fincludeTotalApps: action.count,
        finstreamTotalApps: state.finstreamTotalApps,
        finscoreTotalUploads: state.finscoreTotalUploads,
        totalChargeableCalls: state.totalChargeableCalls,
        totalApiCalls: state.totalApiCalls,
        successRate: state.successRate,
      };

    case types.FINSTREAM_APPS_SUCCESS:
      return {
        ...state.dashboard,
        finstreamTotalApps: action.count,
        fincludeTotalApps: state.fincludeTotalApps,
        finscoreTotalUploads: state.finscoreTotalUploads,
        totalChargeableCalls: state.totalChargeableCalls,
        totalApiCalls: state.totalApiCalls,
        successRate: state.successRate,
      };
    default:
      return state;
  }
}
